module.exports = __webpack_public_path__ + "static/abdulsalam-f6c066fa0cc18f9426d620a4de1f40d9.jpg";